import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const openSidebar = () => setSidebarOpen(true);
  const closeSidebar = () => setSidebarOpen(false);

  const handleSubmenuToggle = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const parentLi = e.currentTarget.parentElement;
    if (parentLi) {
      parentLi.classList.toggle('submenu-open');
    }
  };

  useEffect(() => {
    // Remove preloader after page load
    const loading = document.getElementById('loading');
    if (loading) {
      setTimeout(() => {
        loading.style.display = 'none';
      }, 1000);
    }


    // Sticky header on scroll
    const handleScroll = () => {
      const header = document.querySelector('.header-area');
      if (header) {
        if (window.scrollY > 100) {
          header.classList.add('sticky');
        } else {
          header.classList.remove('sticky');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {/* Preloader */}
      <div id="loading">
        <div id="loading-center">
          <div id="loading-center-absolute">
            <div className="loading-icon text-center d-flex flex-column align-items-center justify-content-center">
              <img className="loading-logo" src="/assets/images/preloader.svg" alt="icon" />
            </div>
          </div>
        </div>
      </div>

      {/* Top header area */}
      <div className="header-top d-none d-lg-block">
        <div className="container">
          <div className="header-top-wrp">
            <ul className="info">
              <li>
                <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd"
                    d="M13.8748 8.50453C13.8748 9.85566 12.7757 10.953 11.4263 10.953H3.39325C2.04384 10.953 0.94475 9.85563 0.94475 8.50453V3.39322C0.944449 2.95776 1.06111 2.53021 1.28253 2.15525L5.20216 6.07488C5.78856 6.663 6.57384 6.98706 7.41059 6.98706C8.24563 6.98706 9.03091 6.663 9.61731 6.07488L13.5369 2.15525C13.7584 2.5302 13.875 2.95776 13.8747 3.39322V8.50453H13.8748ZM11.4263 0.94475H3.39325C2.836 0.94475 2.32159 1.13334 1.91009 1.44712L5.86916 5.40791C6.27897 5.81597 6.82591 6.04231 7.41059 6.04231C7.99356 6.04231 8.54053 5.81597 8.95031 5.40791L12.9094 1.44712C12.4979 1.13334 11.9835 0.94475 11.4263 0.94475ZM11.4263 0H3.39325C1.52259 0 0 1.52259 0 3.39325V8.50456C0 10.3769 1.52259 11.8978 3.39325 11.8978H11.4263C13.2969 11.8978 14.8195 10.3769 14.8195 8.50456V3.39322C14.8195 1.52256 13.2969 0 11.4263 0Z"
                    fill="white" />
                </svg>
                <a href="mailto:newlifenepal071@gmail.com" className="ms-1">newlifenepal071@gmail.com</a>
              </li>
              <li className="ms-4">
                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_529_224)">
                    <path
                      d="M14.8984 10.5909C14.8735 10.5703 12.0629 8.57063 11.304 8.69297C10.9379 8.75766 10.7288 9.0075 10.3093 9.50719C10.1933 9.6463 10.0747 9.7832 9.95352 9.91781C9.68836 9.83143 9.42973 9.72616 9.17961 9.60281C7.88845 8.97422 6.84524 7.93101 6.21665 6.63984C6.0933 6.38973 5.98803 6.1311 5.90165 5.86594C6.03946 5.73984 6.23258 5.57719 6.31508 5.50781C6.81243 5.09062 7.0618 4.88109 7.12649 4.51453C7.25915 3.75562 5.24915 0.945937 5.22852 0.920625C5.13698 0.790808 5.01777 0.682933 4.87948 0.604789C4.74118 0.526645 4.58726 0.480181 4.42883 0.46875C3.61415 0.46875 1.28821 3.48563 1.28821 3.99422C1.28821 4.02375 1.33086 7.02562 5.03258 10.7911C8.79383 14.4886 11.7957 14.5312 11.8252 14.5312C12.3334 14.5312 15.3507 12.2053 15.3507 11.3906C15.3392 11.2322 15.2926 11.0783 15.2144 10.94C15.1362 10.8017 15.0282 10.6825 14.8984 10.5909Z"
                      fill="white" />
                  </g>
                </svg>
                <a href="tel:+977-9851031573" className="ms-1">+977 9851031573</a>
              </li>
            </ul>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <ul className="link-info" style={{ margin: 0 }}>
                <li><a href="https://facebook.com/newlifenepal" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook-f"></i></a></li>
                <li><a href="https://instagram.com/newlifenepal_nln" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram"></i></a></li>
                <li><a href="https://wa.me/+9779851031573" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp"></i></a></li>
              </ul>
              <div style={{ 
                borderLeft: '1px solid rgba(255, 255, 255, 0.2)', 
                paddingLeft: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center'
              }}>
                <Link to="/admin/dashboard" style={{ 
                  color: '#ffffff', 
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: 500,
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#03A84A'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}>
                  <i className="fa-solid fa-user-shield" style={{ marginRight: '6px' }}></i>
                  Admin
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Header area */}
      <header className="header-area">
        <div className="container">
          <div className="header__main">
            <Link to="/" className="logo">
              <img src="/assets/images/logo/logo.svg" alt="New Life Nepal" />
            </Link>
            <div className="main-menu">
              <nav>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="#">About Us</Link>
                  <ul className="sub-menu">
                    <li><Link to="/about/m">Message from Chairperson</Link></li>
                    <li><Link to="/about">What we Do</Link></li>
                    <li><Link to="/about/mission">Our Mission</Link></li>
                    <li><Link to="/about/team">Our Team</Link></li>
                    <li><Link to="/volunteers">Our Volunteers</Link></li>
                    <li><Link to="/children">Our Children</Link></li>
                  </ul>
                  </li>
                  <li><Link to="/updates">Updates</Link></li>
                  <li>
                    <Link to="#">Be Involved</Link>
                    <ul className="sub-menu">
                      <li><Link to="/projects">Volunteer</Link></li>
                      <li><Link to="/sponsor">Sponsor an Event</Link></li>
                      <li><Link to="/donate">Donate</Link></li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/events">Gallery</Link>
                  </li>
                
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </nav>
            </div>
            <div className="btn-two d-none d-lg-inline-block">
              <span className="btn-circle"></span>
              <Link to="/donate" className="btn-inner">
                <span className="btn-text">DONATE NOW</span>
              </Link>
            </div>
            <div className="bars d-block d-lg-none">
              <button onClick={openSidebar} className="btn-transparent"><i id="openButton" className="fa-solid fa-bars"></i></button>
            </div>
          </div>
        </div>
      </header>

      {/* Sidebar area */}
      <div id="targetElement" className={`sidebar-area ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        <div className={`sidebar__overlay ${isSidebarOpen ? 'active' : ''}`} onClick={closeSidebar}></div>
        <div className="sidebar__content">
          <div className="sidebar__close">
            <button onClick={closeSidebar} id="closeButton" className="btn-transparent text-white"><i className="fa-solid fa-xmark"></i></button>
          </div>
          <Link to="/" className="logo mb-40" onClick={closeSidebar}>
            <img src="/assets/images/logo/logo-light.svg" alt="logo" />
          </Link>
          <div className="mobile-menu overflow-hidden">
            <nav>
              <ul>
                <li><Link to="/" onClick={closeSidebar}>Home</Link></li>
                <li className="has-submenu">
                  <Link to="#" onClick={handleSubmenuToggle}>About Us</Link>
                  <ul className="sub-menu">
                    <li><Link to="/about/m" onClick={closeSidebar}>Message from Chairperson</Link></li>
                    <li><Link to="/about" onClick={closeSidebar}>What we Do</Link></li>
                    <li><Link to="/about/mission" onClick={closeSidebar}>Our Mission</Link></li>
                    <li><Link to="/about/team" onClick={closeSidebar}>Our Team</Link></li>
                    <li><Link to="/volunteers" onClick={closeSidebar}>Our Volunteers</Link></li>
                    <li><Link to="/children" onClick={closeSidebar}>Our Children</Link></li>
                  </ul>
                </li>
                <li><Link to="/updates" onClick={closeSidebar}>Updates</Link></li>
                <li className="has-submenu">
                  <Link to="#" onClick={handleSubmenuToggle}>Be Involved</Link>
                  <ul className="sub-menu">
                    <li><Link to="/projects" onClick={closeSidebar}>Volunteer</Link></li>
                    <li><Link to="/sponsor" onClick={closeSidebar}>Sponsor an Event</Link></li>
                    <li><Link to="/donate" onClick={closeSidebar}>Donate</Link></li>
                  </ul>
                </li>
                <li>
                  <Link to="/events" onClick={closeSidebar}>Gallery</Link>
                </li>
              
                <li><Link to="/contact" onClick={closeSidebar}>Contact</Link></li>
              </ul>
            </nav>
          </div>
          <ul className="info pt-40">
            <li><i className="fa-solid primary-color fa-location-dot"></i> <a href="mailto:info@newlifenepal.org">info@newlifenepal.org</a></li>
            <li className="py-2"><i className="fa-solid primary-color fa-phone-volume"></i> <a href="tel:+977-9851031573">+977-9851031573</a></li>
            <li><i className="fa-solid primary-color fa-paper-plane"></i> <a href="mailto:newlifenepal071@gmail.com">newlifenepal071@gmail.com</a></li>
          </ul>
          <div className="social-icon mt-20">
            <a href="https://facebook.com/newlifenepal" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook-f"></i></a>
            <a href="https://instagram.com/newlifenepal_nln" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram"></i></a>
            <a href="https://wa.me/+9779851031573" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp"></i></a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
